var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#viber';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-viber';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?viber#viber';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?viber#view-viber';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 54 54',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };